import { ethers } from 'ethers'
import { useCallback, useEffect, useState } from 'react'
import { useProvider } from 'wagmi'

export default function useBalance(account: `0x${string}` | undefined, watch = true) {
	const provider = useProvider()
	const [balance, setBalance] = useState<string>()
	const [error, setError] = useState<unknown>()

	const fetchBalance = useCallback(async () => {
		try {
			const balance = await provider.getBalance(account as string)
			const formattedBalance = ethers.utils.formatEther(balance)
			setBalance(formattedBalance)
		} catch (err) {
			setError(err)
		}
	}, [account, provider])

	useEffect(() => {
		if (account && ethers.utils.isAddress(account)) {
			fetchBalance()
			if (watch) {
				provider.on('block', fetchBalance)
				return () => {
					provider.off('block', fetchBalance)
				}
			}
		}
	}, [account, provider, fetchBalance, watch])

	return { balance, error }
}
